import React from 'react';
import { mainGreen } from 'styles/variables';

export const BackIcon = React.forwardRef((props, ref) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props} ref={ref}>
        <g fill={props.fill || '#1D1D1B'} fillRule='evenodd'>
            <circle cx='17' cy='17' r='17' fillRule='nonzero' opacity='.103' />
            <path fillRule='nonzero' d='M15.05 17.113l4.578 4.578-1.526 1.525L12 17.114 18.113 11l1.525 1.526z' />
        </g>
    </svg>
));

export const CheckBoxIcon = (props) => {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' {...props}>
            <g fill='none' fillRule='evenodd'>
                <g fillRule='nonzero'>
                    <path
                        fill='#6d62ef'
                        d='M5.279 0h9.442c1.836 0 2.501.191 3.173.55.67.359 1.197.885 1.556 1.556.359.672.55 1.337.55 3.173v9.442c0 1.836-.191 2.501-.55 3.173-.359.67-.885 1.197-1.556 1.556-.672.359-1.337.55-3.173.55H5.28c-1.836 0-2.501-.191-3.173-.55-.67-.359-1.197-.885-1.556-1.556C.191 17.222 0 16.557 0 14.72V5.28c0-1.836.191-2.501.55-3.173C.909 1.436 1.435.91 2.106.55 2.778.191 3.443 0 5.28 0z'
                        transform='translate(-386 -608) translate(372 594) translate(14 14)'
                    />
                    <path
                        fill='#FFF'
                        d='M7.884 8.362L14.827 15.207 13.592 16.425 5.415 8.363 10.363 3.484 11.598 4.701z'
                        transform='translate(-386 -608) translate(372 594) translate(14 14) rotate(-90 10.121 9.954)'
                    />
                </g>
            </g>
        </svg>
    );
};

export const EmptyCheckBoxIcon = (props) => {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' {...props}>
            <g fill='#B7B9BE' fillRule='evenodd' opacity='.253'>
                <path
                    d='M5.279 0h9.442c1.836 0 2.501.191 3.173.55.67.359 1.197.885 1.556 1.556.359.672.55 1.337.55 3.173v9.442c0 1.836-.191 2.501-.55 3.173-.359.67-.885 1.197-1.556 1.556-.672.359-1.337.55-3.173.55H5.28c-1.836 0-2.501-.191-3.173-.55-.67-.359-1.197-.885-1.556-1.556C.191 17.222 0 16.557 0 14.72V5.28c0-1.836.191-2.501.55-3.173C.909 1.436 1.435.91 2.106.55 2.778.191 3.443 0 5.28 0z'
                    transform='translate(-360 -645) translate(346 594) translate(14 51)'
                />
            </g>
        </svg>
    );
};

export const ShowPassIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <g fill='none' fillRule='evenodd' opacity='.204' transform='translate(10 13)'>
            <path
                fillRule='nonzero'
                stroke='#1D1D1B'
                strokeWidth='1.4'
                d='M14 4c-2.008 2.667-4.342 4-7 4-2.658 0-4.992-1.333-7-4 2.008-2.667 4.342-4 7-4 2.658 0 4.992 1.333 7 4z'
            />
            <circle cx='7' cy='3' r='3' fill='#1D1D1B' />
        </g>
    </svg>
);

export const ClearIcon = React.forwardRef((props, ref) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props} ref={ref}>
        <g fill='#1D1D1B' fillRule='nonzero'>
            <path d='M17 28c6.075 0 11-4.925 11-11S23.075 6 17 6 6 10.925 6 17s4.925 11 11 11z' opacity='.146' />
            <path d='M18.206 17.1l2.707 2.737-1.206 1.218L17 18.32l-2.706 2.736-1.206-1.219 2.707-2.736L13 14.275l1.206-1.22L17 15.881l2.794-2.826L21 14.275z' />
        </g>
    </svg>
));
export const DeleteRangeIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            d='M18.5256 17.111L21.9505 20.5359L20.4255 22.0609L17.0004 18.6363L13.5759 22.0608L12.0503 20.5352L15.4747 17.1108L11.939 13.5755L13.4645 12.0499L17.0001 15.5855L20.5356 12.0499L22.0611 13.5755L18.5256 17.111Z'
            fill='currentColor'
        />
    </svg>
);
export const CloseIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            fill='#1D1D1B'
            fillRule='nonzero'
            d='M18.526 17.111l3.425 3.425-1.525 1.525L17 18.636l-3.424 3.425-1.526-1.526 3.425-3.424-3.536-3.536 1.526-1.525L17 15.585l3.536-3.535 1.525 1.525z'
            opacity='.3'
        />
    </svg>
);

export const CalendarIcon = React.forwardRef((props, ref) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props} ref={ref}>
        <path
            fill='currentColor'
            fillRule='nonzero'
            d='M24.008 8c1.1 0 1.992.93 1.992 2.08V24.71c0 1.148-.892 2.08-1.992 2.08H9.992c-1.1 0-1.992-.932-1.992-2.08V10.08C8 8.931 8.892 8 9.992 8h14.016zm.96 5.699H9.032V24.71c0 .553.43 1.001.959 1.001h14.016c.53 0 .96-.448.96-1V13.698zm-9.56 9.472l2.666-6.057h-3.5v-1.091h4.795v.85l-2.666 6.298h-1.295z'
        />
    </svg>
));

export const ExpandIcon = React.forwardRef((props, ref) => (
    <svg width='2.125rem' height='2.125rem' viewBox='8 8 18 18' {...props} ref={ref}>
        <path
            fill={props.fill || '#1D1D1B'}
            fillRule='nonzero'
            d='M16.825 18.877l4.577-4.577 1.525 1.525-6.102 6.102-6.114-6.113 1.526-1.525z'
        />
    </svg>
));

export const LightExpandIcon = React.forwardRef((props, ref) => (
    <svg width='2rem' height='2rem' viewBox='0 0 32 32' {...props} ref={ref}>
        <g fill='#1D1D1B' fillRule='nonzero'>
            <path
                d='M31.059 16C31.059 7.683 24.317.941 16 .941S.941 7.683.941 16 7.683 31.059 16 31.059 31.059 24.317 31.059 16z'
                opacity='.104'
            />
            <path d='M16.107 17.835l4.308-4.308 1.436 1.436-5.744 5.743-5.754-5.753 1.436-1.436z' />
        </g>
    </svg>
));

export const MapMarker = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path
            fill='#c5c5c4'
            fillRule='evenodd'
            d='M17.433 6.012c4.683.213 8.489 4.143 8.566 8.833.047 2.531-1.221 4.594-2.597 6.485C22.075 23.15 17 28.618 17 28.618s-5.075-5.468-6.402-7.288C9.222 19.44 7.954 17.376 8 14.845c.077-4.69 3.883-8.62 8.566-8.833.148-.006.29-.012.433-.012.143 0 .285.006.433.012zm-5.119 8.99a4.685 4.685 0 1 0 9.37-.001 4.685 4.685 0 0 0-9.37 0z'
        />
    </svg>
);

export const SmallLogo = ({ color, active, activeColor, opacity, ...props }) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path
            fill={(active && activeColor) || color || '#FFF'}
            fillRule='nonzero'
            d='M20.137 2C27.76 2 33 5.246 33 11.477c0 5.296-3.787 8.437-9.605 9.26a23.36 23.36 0 0 1-3.258.217c-5.485 0-9.738-1.68-11.688-4.946 1.378 3.942 5.159 6.19 11.101 6.19 1.142 0 2.234-.073 3.26-.22-.729 2.89-3.498 4.865-7.405 5.572.07 1.335.336 2.258.959 3.082-1.8-.42-4.337-2.793-4.337-2.793C5.49 27.839 1 25.054 1 19.714c0-3.678 2.35-6.718 6.287-7.647C7.28 11.872 7.44 2 20.137 2zm6.116 18.526c.91 0 1.694.515 1.694 1.674 0 1.18-.785 1.695-1.694 1.695-.889 0-1.674-.515-1.674-1.695 0-1.159.785-1.674 1.674-1.674zm2.531 3.369c.455 0 .848.257.848.836 0 .59-.393.848-.848.848-.444 0-.837-.258-.837-.848 0-.579.393-.836.837-.836z'
            opacity={opacity || '.403'}
        />
    </svg>
);

export const FacebookIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path
            fill='#FFF'
            fillRule='evenodd'
            d='M23.5 5.17v3.787l-2.449.006c-1.92 0-2.29.837-2.29 2.06v2.71h4.573l-.593 4.239h-3.98V29h-4.768V17.972H10v-4.238h3.993v-3.126c0-3.63 2.41-5.608 5.942-5.608 1.684 0 3.138.117 3.565.17z'
        />
    </svg>
);

export const LinkedInIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path
            fill='#FFF'
            fillRule='nonzero'
            d='M28 27h-4.52v-7.7c0-2.11-.802-3.29-2.473-3.29-1.818 0-2.767 1.228-2.767 3.29V27h-4.357V12.333h4.357v1.976s1.31-2.424 4.422-2.424c3.11 0 5.338 1.9 5.338 5.829V27zM8.686 10.413A2.696 2.696 0 0 1 6 7.706 2.696 2.696 0 0 1 8.686 5a2.696 2.696 0 0 1 2.686 2.706 2.696 2.696 0 0 1-2.686 2.707zM6.436 27h4.543V12.333H6.437V27z'
        />
    </svg>
);

export const TwitterIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path
            fill='#FFF'
            fillRule='nonzero'
            d='M25.748 12.453c.285 6.348-4.449 13.426-12.83 13.426-2.548 0-4.92-.747-6.918-2.028a9.075 9.075 0 0 0 6.682-1.87 4.517 4.517 0 0 1-4.216-3.133 4.527 4.527 0 0 0 2.038-.077c-2.17-.437-3.669-2.392-3.62-4.483a4.49 4.49 0 0 0 2.045.564 4.518 4.518 0 0 1-1.397-6.026 12.812 12.812 0 0 0 9.303 4.716C16.177 10.72 18.318 8 21.232 8c1.298 0 2.471.548 3.294 1.425a9.027 9.027 0 0 0 2.866-1.095 4.522 4.522 0 0 1-1.985 2.497 9.015 9.015 0 0 0 2.593-.71 9.163 9.163 0 0 1-2.252 2.336'
        />
    </svg>
);

export const PlusIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <g fill='#FFF' fillRule='evenodd'>
            <path d='M24 18H10v-2h14z' />
            <path d='M16 24V10h2v14z' />
            <path
                fillRule='nonzero'
                d='M17 33c8.837 0 16-7.163 16-16S25.837 1 17 1 1 8.163 1 17s7.163 16 16 16zm0-1.62C9.058 31.38 2.62 24.942 2.62 17 2.62 9.058 9.058 2.62 17 2.62c7.942 0 14.38 6.438 14.38 14.38 0 7.942-6.438 14.38-14.38 14.38z'
            />
        </g>
    </svg>
);

export const PlusWithoutCircleIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <g fill='#FFF' fillRule='evenodd'>
            <path d='M24 18H10v-2h14z' />
            <path d='M16 24V10h2v14z' />
        </g>
    </svg>
);

export const PlusIconWhiteCircle = (props) => (
    <svg width='1.5rem' height='1.5rem' viewBox='0 0 24 24' {...props}>
        <defs>
            <filter id='a' width='200%' height='200%' x='-50%' y='-50%' filterUnits='objectBoundingBox'>
                <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
                <feGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='2' />
                <feColorMatrix
                    in='shadowBlurOuter1'
                    result='shadowMatrixOuter1'
                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
                />
                <feMerge>
                    <feMergeNode in='shadowMatrixOuter1' />
                    <feMergeNode in='SourceGraphic' />
                </feMerge>
            </filter>
        </defs>
        <g fill='none' fillRule='evenodd' filter='url(#a)'>
            <path
                fill='#FFF'
                fillRule='nonzero'
                d='M12 22.15C6.394 22.15 1.85 17.606 1.85 12 1.85 6.394 6.394 1.85 12 1.85c5.606 0 10.15 4.544 10.15 10.15 0 5.606-4.544 10.15-10.15 10.15z'
            />
            <path
                fill='#24CE6E'
                d='M12.706 7.059v4.235h4.235v1.412h-4.235v4.235h-1.412v-4.235H7.059v-1.412h4.235V7.059h1.412z'
            />
        </g>
    </svg>
);

export const RightArrowIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path
            fill='currentColor'
            fillRule='nonzero'
            d='M18.588 17.103l-4.577-4.577L15.536 11l6.102 6.102-6.112 6.114L14 21.691z'
        />
    </svg>
);

export const LeftArrowIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <g transform='scale(-1, 1) translate(-34, 0)'>
            <path
                fill='currentColor'
                fillRule='nonzero'
                d='M18.588 17.103l-4.577-4.577L15.536 11l6.102 6.102-6.112 6.114L14 21.691z'
            />
        </g>
    </svg>
);
export const TopArrowIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <g transform='rotate(-90 17 17)'>
            <path
                fill='currentColor'
                fillRule='nonzero'
                d='M18.588 17.103l-4.577-4.577L15.536 11l6.102 6.102-6.112 6.114L14 21.691z'
            />
        </g>
    </svg>
);
export const BottomArrowIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <g transform='rotate(90 17 17)'>
            <path
                fill='currentColor'
                fillRule='nonzero'
                d='M18.588 17.103l-4.577-4.577L15.536 11l6.102 6.102-6.112 6.114L14 21.691z'
            />
        </g>
    </svg>
);

export const AddRowIcon = (props) => (
    <svg width='100%' height='100%' viewBox='0 0 34 34' {...props}>
        <path
            fill='#1D1D1B'
            d='M2.67829 16.7835C2.53621 16.7835 2.39995 16.8399 2.29949 16.9404C2.19902 17.0409 2.14258 17.1771 2.14258 17.3192C2.14258 17.4613 2.19902 17.5975 2.29949 17.698C2.39995 17.7985 2.53621 17.8549 2.67829 17.8549H17.3211C17.4632 17.8549 17.5995 17.7985 17.7 17.698C17.8004 17.5975 17.8569 17.4613 17.8569 17.3192C17.8569 17.1771 17.8004 17.0409 17.7 16.9404C17.5995 16.8399 17.4632 16.7835 17.3211 16.7835H2.67829ZM17.8569 7.85491V11.4263C17.8569 11.6158 17.7816 11.7975 17.6477 11.9314C17.5137 12.0654 17.332 12.1406 17.1426 12.1406H13.214V7.85491H17.8569ZM17.8569 4.8192V6.78348H13.214V2.14062H15.1783C15.8887 2.14062 16.57 2.42283 17.0723 2.92516C17.5747 3.42749 17.8569 4.1088 17.8569 4.8192ZM7.85686 2.14062H12.1426V6.78348H7.85686V2.14062ZM4.82115 2.14062H6.78544V6.78348H2.14258V4.8192C2.14258 4.1088 2.42478 3.42749 2.92711 2.92516C3.42944 2.42283 4.11075 2.14063 4.82115 2.14062ZM2.85686 12.1406C2.66742 12.1406 2.48574 12.0654 2.35179 11.9314C2.21783 11.7975 2.14258 11.6158 2.14258 11.4263V7.85491H6.78544V12.1406H2.85686ZM12.1426 7.85491H7.85686V12.1406H8.74972V11.4263C8.74972 11.0948 8.88142 10.7769 9.11584 10.5425C9.35026 10.308 9.6682 10.1763 9.99972 10.1763C10.3312 10.1763 10.6492 10.308 10.8836 10.5425C11.118 10.7769 11.2497 11.0948 11.2497 11.4263V12.1406H12.1426V7.85491ZM8.74829 13.3478L9.46401 13.9835V11.4263C9.46401 11.2843 9.52045 11.148 9.62091 11.0475C9.72138 10.9471 9.85764 10.8906 9.99972 10.8906C10.1418 10.8906 10.2781 10.9471 10.3785 11.0475C10.479 11.148 10.5354 11.2843 10.5354 11.4263V13.9835L11.2512 13.3478C11.3581 13.26 11.4949 13.2171 11.6329 13.2279C11.7708 13.2388 11.8992 13.3026 11.9912 13.406C12.0832 13.5094 12.1315 13.6444 12.1262 13.7826C12.1209 13.9209 12.0622 14.0518 11.9626 14.1478L10.3554 15.5763C10.2574 15.6634 10.1308 15.7115 9.99972 15.7115C9.86861 15.7115 9.74204 15.6634 9.64401 15.5763L8.03686 14.1478C7.93721 14.0518 7.87858 13.9209 7.87324 13.7826C7.8679 13.6444 7.91628 13.5094 8.00824 13.406C8.10019 13.3026 8.2286 13.2388 8.36655 13.2279C8.5045 13.2171 8.6413 13.26 8.74829 13.3478Z'
        />
    </svg>
);
export const AddColumnIcon = (props) => (
    <svg width='2.5rem' height='2.5rem' viewBox='0 0 34 34' {...props}>
        <path
            fill='#1D1D1B'
            d='M16.7854 17.3192C16.7854 17.4613 16.8419 17.5975 16.9423 17.698C17.0428 17.7985 17.1791 17.8549 17.3211 17.8549C17.4632 17.8549 17.5995 17.7985 17.7 17.698C17.8004 17.5975 17.8569 17.4613 17.8569 17.3192V2.67634C17.8569 2.53426 17.8004 2.398 17.7 2.29753C17.5995 2.19707 17.4632 2.14062 17.3211 2.14062C17.1791 2.14062 17.0428 2.19707 16.9423 2.29753C16.8419 2.398 16.7854 2.53426 16.7854 2.67634V17.3192ZM7.85686 2.14062H11.7854C11.8802 2.14062 11.971 2.17825 12.038 2.24523C12.105 2.31221 12.1426 2.40305 12.1426 2.49777V6.78348H7.85686V2.14062ZM4.82115 2.14062H6.78544V6.78348H2.14258V4.8192C2.14258 4.1088 2.42478 3.42749 2.92711 2.92516C3.42944 2.42283 4.11075 2.14063 4.82115 2.14062ZM2.14258 12.1406V7.85491H6.78544V12.1406H2.14258ZM2.14258 15.1763V13.2121H6.78544V17.8549H4.82115C4.11075 17.8549 3.42944 17.5727 2.92711 17.0704C2.42478 16.568 2.14258 15.8867 2.14258 15.1763ZM12.1426 17.4978C12.1426 17.5925 12.105 17.6833 12.038 17.7503C11.971 17.8173 11.8802 17.8549 11.7854 17.8549H7.85686V13.2121H12.1426V17.4978ZM7.85686 7.85491V12.1406H12.1426V11.2478H11.4283C11.0968 11.2478 10.7788 11.1161 10.5444 10.8817C10.31 10.6472 10.1783 10.3293 10.1783 9.99777C10.1783 9.66625 10.31 9.3483 10.5444 9.11388C10.7788 8.87946 11.0968 8.74777 11.4283 8.74777H12.1426V7.85491H7.85686ZM13.3497 11.2492L13.9854 10.5335H11.4283C11.2862 10.5335 11.15 10.477 11.0495 10.3766C10.949 10.2761 10.8926 10.1398 10.8926 9.99777C10.8926 9.85569 10.949 9.71943 11.0495 9.61896C11.15 9.5185 11.2862 9.46205 11.4283 9.46205H13.9854L13.3497 8.74634C13.262 8.63935 13.219 8.50255 13.2299 8.36459C13.2407 8.22664 13.3045 8.09824 13.4079 8.00628C13.5113 7.91433 13.6463 7.86595 13.7846 7.87129C13.9229 7.87662 14.0537 7.93526 14.1497 8.03491L15.5783 9.64205C15.6654 9.74009 15.7134 9.86665 15.7134 9.99777C15.7134 10.1289 15.6654 10.2554 15.5783 10.3535L14.1497 11.9606C14.0537 12.0603 13.9229 12.1189 13.7846 12.1242C13.6463 12.1296 13.5113 12.0812 13.4079 11.9893C13.3045 11.8973 13.2407 11.7689 13.2299 11.6309C13.219 11.493 13.262 11.3562 13.3497 11.2492Z'
        />
    </svg>
);
export const RectangleUpIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path fill='#1D1D1B' fillRule='nonzero' d='M11 20.986L16.994 13 23 21z' />
    </svg>
);

export const RectangleDownIcon = (props) => (
    <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
        <path fill='#1D1D1B' fillRule='nonzero' d='M23 14.014L17.006 22 11 14z' />
    </svg>
);

export const ExclamationIcon = (props) => {
    const { color = '#F55A5A' } = props;
    return (
        <svg width='2.125rem' height='2.125rem' viewBox='0 0 34 34' {...props}>
            <g fill='none' fillRule='nonzero'>
                <path
                    fill={color}
                    stroke='#FFF'
                    strokeWidth='2'
                    d='M17 29c-6.627 0-12-5.373-12-12S10.373 5 17 5s12 5.373 12 12-5.373 12-12 12z'
                />
                <path fill='#FFF' d='M16 11l2 .006V19h-2v-8zm0 10l2 .002V23h-2v-2z' />
            </g>
        </svg>
    );
};

export const GreyCheckIcon = (props) => (
    <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
        <g fill='#1D1D1B' fillRule='evenodd'>
            <path d='M14 23.059A9.059 9.059 0 1 0 14 4.94a9.059 9.059 0 0 0 0 18.118z' opacity='.2' />
            <path fillRule='nonzero' d='M13.01 15.75l5.3-5.218.942.928-6.242 6.145-3.778-3.718.943-.928z' />
        </g>
    </svg>
);

export const GreenCheckIcon = (props) => (
    <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
        <g fill='none' fillRule='nonzero'>
            <path fill={mainGreen} d='M14 23.059A9.059 9.059 0 1 0 14 4.94a9.059 9.059 0 0 0 0 18.118z' />
            <path fill='#FFF' d='M13.01 15.75l5.3-5.218.942.928-6.242 6.145-3.778-3.718.943-.928z' />
        </g>
    </svg>
);

export const GreyPlayButtonIcon = (props) => (
    <svg width='54' height='54' viewBox='0 0 54 54' {...props}>
        <g fill='#FFF' fillRule='nonzero'>
            <path
                d='M27 52.412c14.035 0 25.412-11.377 25.412-25.412C52.412 12.965 41.035 1.588 27 1.588 12.965 1.588 1.588 12.965 1.588 27c0 14.035 11.377 25.412 25.412 25.412z'
                opacity='.202'
            />
            <path d='M22.154 18.277l14.356 7.836a1 1 0 0 1 0 1.756L22.129 35.72a1 1 0 0 1-1.48-.879l.026-15.688a1 1 0 0 1 1.48-.876z' />
        </g>
    </svg>
);

export const GreenPlayButtonIcon = (props) => (
    <svg width='54' height='54' viewBox='0 0 54 54' {...props}>
        <g fill='none' fillRule='nonzero'>
            <path
                fill='#24CE6E'
                d='M27 52.412c14.035 0 25.412-11.377 25.412-25.412C52.412 12.965 41.035 1.588 27 1.588 12.965 1.588 1.588 12.965 1.588 27c0 14.035 11.377 25.412 25.412 25.412z'
            />
            <path
                fill='#FFF'
                d='M22.154 18.277l14.356 7.836a1 1 0 0 1 0 1.756L22.129 35.72a1 1 0 0 1-1.48-.879l.026-15.688a1 1 0 0 1 1.48-.876z'
            />
        </g>
    </svg>
);

export const LightExclamationIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <g fill='#F55A5A' fillRule='nonzero'>
            <path d='M17 28c6.075 0 11-4.925 11-11S23.075 6 17 6 6 10.925 6 17s4.925 11 11 11z' opacity='.146' />
            <path d='M16 11l2 .006V19h-2v-8zm0 10l2 .002V23h-2v-2z' />
        </g>
    </svg>
);

export const StarIcon = ({ color, className, width, height }) => (
    <svg className={className} width={width} height={height} viewBox='0 0 15 14'>
        <linearGradient id='half'>
            <stop offset='50%' stopColor='#f7b500' />
            <stop offset='50%' stopColor='#dad7d7' />
        </linearGradient>
        <path
            fill={color}
            fillRule='nonzero'
            d='M3.2 14l-.542-.387.662-4.648L0 5.587l.207-.626 4.71-.819L7.164 0h.67l2.249 4.142 4.709.819.207.626-3.32 3.378.662 4.648L11.8 14l-4.3-2.054z'
        />
    </svg>
);

StarIcon.defaultProps = {
    width: '15',
    height: '14',
};

export const SearchIcon = ({ color, className, ...rest }) => (
    <svg className={className} width='34' height='34' viewBox='0 0 34 34' {...rest}>
        <g
            fill='none'
            fillRule='evenodd'
            stroke={color || '#E3E3E2'}
            strokeWidth='2'
            transform='rotate(-45 19.95 .222)'
        >
            <circle cx='6' cy='6' r='6' />
            <path d='M6 12v8' />
        </g>
    </svg>
);

export const DotsIcon = (props) => (
    <svg width='24' height='24' viewBox='0 0 24 24' {...props}>
        <path
            fill={props.fill || '#1D1D1B'}
            fillRule='evenodd'
            d='M6.51 13.725a1.57 1.57 0 0 1-1.569-1.568 1.57 1.57 0 0 1 1.569-1.569 1.57 1.57 0 0 1 1.568 1.569 1.57 1.57 0 0 1-1.568 1.568zm5.49 0a1.57 1.57 0 0 1-1.569-1.568A1.57 1.57 0 0 1 12 10.588a1.57 1.57 0 0 1 1.569 1.569 1.57 1.57 0 0 1-1.57 1.568zm5.49 0a1.57 1.57 0 0 1-1.568-1.568 1.57 1.57 0 0 1 1.568-1.569 1.57 1.57 0 0 1 1.569 1.569 1.57 1.57 0 0 1-1.569 1.568z'
            opacity={props.opacity || '.3'}
        />
    </svg>
);

export const QuestionIcon = (props) => (
    <svg width='31' height='30' viewBox='0 0 31 30' {...props}>
        <g fill='none' fillRule='evenodd'>
            <path
                fill={props.fill || '#24CE6E'}
                d='M15.814 4.412c1.54 0 2.96.2 4.223.598l.437.144c3.54 1.275 5.742 4.175 5.742 8.61 0 4.501-2.267 7.42-5.896 8.664l-.277.093c-1.239.387-2.624.587-4.128.594 0 0 0 .003-.003 0l-.047.002h-.051c-.78 0-1.527-.052-2.241-.156-1.368.834-3.128 1.748-5.314 2.627.687-1.373.951-2.695.87-4.225-1.972-1.304-3.269-3.325-3.62-6.041l-.04-.359a12.104 12.104 0 0 1-.057-1.198c0-6.15 4.236-9.353 10.402-9.353z'
            />
            <path
                fill='#FFF'
                d='M15.907 16.838c.527 0 .954.419.954.935v.039l-.006.101a.947.947 0 0 1-.948.834.945.945 0 0 1-.954-.935v-.039l.005-.101a.947.947 0 0 1 .949-.834zm-.172-7.679c.766 0 3.267.218 3.267 2.731 0 1.04-.562 1.655-1.544 2.36l-.18.135c-.42.33-.599.615-.599 1.43h-1.684c0-1.232.127-1.77 1.302-2.604l.11-.08c.43-.328.68-.704.68-1.19 0-1-.701-1.269-1.237-1.269-.961 0-1.234.611-1.335 1.164l-.025.155-.018.156v.013h-1.8c0-2.232 1.672-3.001 3.063-3.001z'
            />
        </g>
    </svg>
);

export const BlackPlusIcon = (props) => (
    <svg width='46' height='46' viewBox='0 0 46 46' {...props}>
        <g fill='none' fillRule='nonzero' opacity='.8'>
            <path
                fill='#1D1D1B'
                d='M23 37.882c8.22 0 14.882-6.663 14.882-14.882 0-8.22-6.663-14.882-14.882-14.882C14.78 8.118 8.118 14.78 8.118 23c0 8.22 6.663 14.882 14.882 14.882z'
            />
            <path
                fill='#FFF'
                d='M24.111 24.27l-.029 5.209-2.319.013.029-5.208-5.207.029.012-2.32 5.208-.029.029-5.376 2.32-.013-.03 5.376 5.376-.03-.013 2.32z'
            />
        </g>
    </svg>
);

export const SendMessageIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            fill='#1D1D1B'
            fillRule='evenodd'
            d='M10.718 8.153l14.545 7.861a1.124 1.124 0 0 1 0 1.941l-14.572 7.891A1.124 1.124 0 0 1 9 24.874l1.078-6.08 7.487-1.796-7.473-1.797-1.064-6.079a1.124 1.124 0 0 1 1.69-.969z'
            opacity='.2'
        />
    </svg>
);

export const MessagesIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            fill='#FFF'
            fillRule='evenodd'
            d='M19.55 5C25.741 5 30 7.835 30 13.276c0 4.624-3.077 7.367-7.803 8.084-.833.128-1.72.191-2.648.191-4.45 0-7.9-1.463-9.491-4.305 1.124 3.432 4.192 5.389 9.014 5.389.928 0 1.814-.063 2.647-.191-.65 2.755-2.863 4.342-6.011 4.894.06 1.146.275 1.948.775 2.662-1.463-.368-2.687-1.208-3.45-2.44h-.074C7.649 27.56 4 25.132 4 20.468c0-3.213 1.913-5.862 5.11-6.675a10.063 10.063 0 0 1-.012-.633C9.158 7.794 13.398 5 19.55 5zm6.95 19c.296 0 .5.171.5.5 0 .28-.147.445-.373.488A.663.663 0 0 1 26.5 25c-.297 0-.5-.171-.5-.5.003-.331.206-.5.5-.5zm-2-3c.889 0 1.5.514 1.5 1.5 0 .838-.442 1.335-1.12 1.465-.12.024-.247.035-.38.035-.837 0-1.427-.455-1.494-1.33L23 22.5v-.02c.009-.973.618-1.48 1.5-1.48z'
        />
    </svg>
);

export const ChatCloseIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <g fill='none' fillRule='evenodd' opacity='.6'>
            <path
                fill='#1D1D1B'
                fillRule='nonzero'
                d='M17 33c8.837 0 16-7.163 16-16S25.837 1 17 1 1 8.163 1 17s7.163 16 16 16z'
            />
            <path
                fill='#FFF'
                d='M23 12.5L18.5 17l4.5 4.5-1.5 1.5-4.5-4.5-4.5 4.5-1.5-1.5 4.5-4.5-4.5-4.5 1.5-1.5 4.5 4.5 4.5-4.5z'
            />
        </g>
    </svg>
);

export const VideoVolumeIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            fill='#FFF'
            fillRule='nonzero'
            d='M17.501 11v12.954l-4.048-2.286H13a4 4 0 0 1-4-4v-.382a4 4 0 0 1 4-4h.453L17.501 11zm6.125 0l.128.302A15.735 15.735 0 0 1 25 17.46c0 2.157-.433 4.253-1.262 6.194l-.128.301-1.494-.883.096-.23a14.02 14.02 0 0 0 1.066-5.382c0-1.857-.36-3.664-1.051-5.344l-.094-.23L23.626 11zm-2.987 1.77l.12.319c.525 1.384.797 2.858.797 4.37 0 1.527-.278 3.016-.812 4.412l-.121.317-1.502-.887.08-.224c.417-1.15.633-2.369.633-3.618a10.6 10.6 0 0 0-.618-3.577l-.08-.223 1.503-.89z'
        />
    </svg>
);

export const VideoVolumeGreenIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            fill='#24CE6E'
            fillRule='nonzero'
            d='M17.501 11v12.954l-4.048-2.286H13a4 4 0 0 1-4-4v-.382a4 4 0 0 1 4-4h.453L17.501 11zm6.125 0l.128.302A15.735 15.735 0 0 1 25 17.46c0 2.157-.433 4.253-1.262 6.194l-.128.301-1.494-.883.096-.23a14.02 14.02 0 0 0 1.066-5.382c0-1.857-.36-3.664-1.051-5.344l-.094-.23L23.626 11zm-2.987 1.77l.12.319c.525 1.384.797 2.858.797 4.37 0 1.527-.278 3.016-.812 4.412l-.121.317-1.502-.887.08-.224c.417-1.15.633-2.369.633-3.618a10.6 10.6 0 0 0-.618-3.577l-.08-.223 1.503-.89z'
        />
    </svg>
);

export const VideoPauseIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path fill='#FFF' fillRule='nonzero' d='M15 10v14h-4V10h4zm8 0v14h-4V10h4z' />
    </svg>
);

export const VideoPlayIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path fill='#FFF' fillRule='nonzero' d='M12.025 10L24 16.987 12 24z' />
    </svg>
);

export const VideoDownloadIcon = (props) => (
    <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
        <path
            fill='#FFF'
            fillRule='evenodd'
            d='M15.961 10h2.078v7.702l2.85-2.851 1.432 1.431L17 21.602l-5.32-5.32 1.43-1.432 2.851 2.85V10zM24 25.961H10v-2h14v2z'
        />
    </svg>
);

export const FullScreenIcon = (props) => (
    <svg width='24' height='24' viewBox='0 0 24 24' {...props}>
        <path
            fill='#FFF'
            fillRule='nonzero'
            d='M6.988 14.822v2.19h2.188v1.27H5.718v-3.46h1.27zm11.294 0v3.46h-3.46v-1.27h2.19v-2.19h1.27zm0-5.646h-1.27V6.988h-2.19v-1.27h3.46v3.458zM9.176 5.718v1.27H6.988v2.187h-1.27V5.719h3.458z'
        />
    </svg>
);

export const GreenPlusIcon = (props) => (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
        <g fill={mainGreen} fillRule='evenodd'>
            <path d='M22.588 16.941H9.412V15.06h13.176z' />
            <path d='M15.059 22.588V9.412h1.882v13.176z' />
        </g>
    </svg>
);
